<template>
	<v-row no-gutters>
		<v-col class="px-1" sm="6" cols="12">
			<h6 class="text-body-1 font-weight-bold">基本情報</h6>
			<table width="100%" class="show-dialog-table show-dialog-table--form mt-2">
				<tbody>
					<ShowDetailRecord :columnName="'名前'">
						<template v-slot:value>
							<v-text-field
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								:rules="[rules.required]"
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'所属'">
						<template v-slot:value>
							<v-select
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								:rules="[rules.required]"
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'郵便番号'">
						<template v-slot:value>
							<v-text-field
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'住所'">
						<template v-slot:value>
							<v-textarea
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'電話番号'">
						<template v-slot:value>
							<v-text-field
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'血液型'">
						<template v-slot:value>
							<v-text-field
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'誕生日'">
						<template v-slot:value>
							<v-row no-gutters>
								<v-col class="pr-1" cols="4">
									<v-combobox
										v-model="year"
										background-color="white"
										dense
										outlined
										hide-details
										:items="years"
										@change="changeBirthDay"
									>
										<template v-slot:append-outer>年</template>
									</v-combobox>
								</v-col>
								<v-col class="px-1" cols="4">
									<v-combobox
										v-model="month"
										background-color="white"
										dense
										outlined
										hide-details
										:items="months"
										@change="changeBirthDay"
									>
										<template v-slot:append-outer>月</template>
									</v-combobox>
								</v-col>
								<v-col class="pl-1" cols="4">
									<v-combobox
										v-model="day"
										background-color="white"
										dense
										outlined
										hide-details
										:items="days"
										@change="changeBirthDay"
									>
										<template v-slot:append-outer>日</template>
									</v-combobox>
								</v-col>
							</v-row>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'備考'">
						<template v-slot:value>
							<v-textarea
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord
						:columnName="'添付資料'"
						:tdStyle="{ backgroundColor: 'white', borderBottom: '1px solid whitesmoke' }"
					>
						<template v-slot:value>
							<div class="pa-2">
								<v-btn dark color="secondary" @click="$refs.uploadFile.click()">
									<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
									添付する
									<input
										type="file"
										class="d-none"
										ref="uploadFile"
										@change="addFiles($event)"
										multiple
									/>
								</v-btn>

								<p v-if="!files.length && !existingFiles.length" class="mt-2 filename no-wrap">
									選択されていません
								</p>
								<v-row
									class="mt-2"
									no-gutters
									v-for="file in existingFiles"
									:key="file.id"
									align="center"
								>
									<a class="d-block mr-2" :href="file.url" target="_blank">{{ file.name }}</a>
									<v-btn icon @click="openDeleteDialog(file)"><v-icon>mdi-delete</v-icon></v-btn>
								</v-row>
								<v-row class="mt-2" no-gutters v-for="file in files" :key="file.id" align="center">
									<a class="d-block mr-2" :href="file.url" target="_blank">{{ file.name }}</a>
									<v-btn icon @click="removeFile(file)"><v-icon>mdi-delete</v-icon></v-btn>
								</v-row>
							</div>
						</template>
					</ShowDetailRecord>
					<tr>
						<th class="bg-white font-weight-bold">緊急連絡先情報</th>
					</tr>
					<ShowDetailRecord :columnName="'連絡先'">
						<template v-slot:value>
							<v-text-field
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'相手の名前'">
						<template v-slot:value>
							<v-text-field
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'作業者との関係'">
						<template v-slot:value>
							<v-text-field
								v-model="worker.todo"
								background-color="white"
								dense
								outlined
								hide-details
							/>
						</template>
					</ShowDetailRecord>
				</tbody>
			</table>
		</v-col>
		<v-col class="px-1 mt-sm-0 mt-4" sm="6" cols="12">
			<h6 class="text-body-1 font-weight-bold">保有資格・作業資格証</h6>
			<table width="100%" class="show-dialog-table show-dialog-table--form mt-2">
				<tbody>
					<tr v-for="(qualification, i) in qualifications" :key="i">
						<th class="font-weight-bold">{{ qualification.name }}</th>
						<td class="bg-white border-bottom">
							<v-checkbox v-model="TODO" hide-details background-color="white" />
						</td>
					</tr>
				</tbody>
			</table>
			<table width="100%" class="show-dialog-table show-dialog-table--form mt-2">
				<tbody>
					<tr v-for="(workerQualification, i) in filterWorkerQualifications" :key="i">
						<th
							v-if="i == 0"
							class="font-weight-bold border-right"
							:rowspan="filterWorkerQualifications.length"
						>
							その他
						</th>
						<td>
							<v-text-field
								background-color="white"
								v-model="workerQualification.name"
								class="append-outer"
								outlined
								dense
								hide-details
							>
								<template v-slot:append-outer>
									<v-btn icon @click="removeQualifications(workerQualification)">
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</td>
					</tr>
				</tbody>
			</table>
			<v-btn class="mt-4" @click="addWorkerQualification" color="secondary">
				<v-icon class="mr-1"> mdi-plus </v-icon>
				その他の入力欄を追加
			</v-btn>
		</v-col>
		<!-- TODO: 要確認 -->
		<ConfirmationDialog
			:dialog.sync="deleteDialog"
			:confirm_options="{
				title: 'ファイルの削除',
				cancel_text: 'キャンセル',
			}"
		>
			<template v-slot:text>
				削除すると元に戻すことはできません。<br />本当によろしいですか。
				<br />
				<br />
				ファイル名：{{ selectedFile.name }}.pdf
			</template>
			<template v-slot:button>
				<v-btn @click="removeFile(selectedFile)" color="red" dark>
					<v-icon class="mr-1">mdi-delete</v-icon>
					削除する
				</v-btn>
			</template>
		</ConfirmationDialog>
	</v-row>
</template>

<script>
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import ConfirmationDialog from "../../shared/ConfirmationDialog.vue"

export default {
	props: {
		worker_data: {
			type: Object,
			default: () => {
				return {}
			},
		},
		existing_files: {
			type: Array,
			default: () => {
				return []
			},
		},
		files_data: {
			type: Array,
			default: () => {
				return []
			},
		},
		qualifications: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {
			rules,
			TODO: null,
			year: null,
			month: null,
			day: null,
			selectedFile: {},
			deleteDialog: false,
		}
	},
	components: {
		ShowDetailRecord,
		ConfirmationDialog,
	},
	methods: {
		changeBirthDay() {
			if (this.year && this.month && this.day) {
				this.worker.birthday = `${this.year}-${this.month}-${this.day}`
			} else {
				this.worker.birthday = null
			}
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		openDeleteDialog(file) {
			this.selectedFile = file
			this.deleteDialog = true
		},
		removeFile(file) {
			// 削除処理
		},
		addWorkerQualification() {
			this.worker.worker_qualifications_attributes.push({
				name: null,
			})
		},
		removeQualifications(workerQualification) {
			const index = this.worker.worker_qualifications_attributes.indexOf(workerQualification)
			if (workerQualification.id) {
				this.worker.worker_qualifications_attributes[index]._destroy = true
			} else {
				this.worker.worker_qualifications_attributes.splice(index, 1)
			}
		},
	},
	computed: {
		worker: {
			get() {
				return this.worker_data
			},
			set(val) {
				this.$emit("update:worker_data", val)
			},
		},
		existingFiles: {
			get() {
				return this.existing_files
			},
			set(val) {
				this.$emit("update:existing_files", val)
			},
		},
		files: {
			get() {
				return this.files_data
			},
			set(val) {
				this.$emit("update:files_data", val)
			},
		},
		filterWorkerQualifications() {
			console.log(this.worker)
			return this.worker.worker_qualifications_attributes.filter((qualification) => {
				return !qualification._destroy
			})
		},
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
	},
}
</script>

<style scoped>
.border-right {
	border-right: 1px solid white;
}
.border-bottom {
	border-bottom: 1px solid whitesmoke;
}
</style>